<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-12">
                <h5 style="padding-bottom: 20px">Denuncia de uso no autorizado de la tarjeta +VIVOS</h5>
              </div>
              <div class="text-center" v-if="loading">
                <img style="max-height: 70px;" v-bind:src="'/img/custom/loading.svg'" />Loading...
              </div>
            </template>
            <template>
              <p v-if="complaint.email">
                Hola <b>{{complaint.first_name}}</b> si no fuiste tu quien redimió un beneficio en <b>{{complaint.ally}}</b> el día <b>{{complaint.date}}</b> por favor completa el siguiente formulario. En caso de ser necesario, nos comunicaremos contigo al correo <b>{{complaint.email}}</b> registrado en nuestro sistema.
              </p>
              <form id="registro" @submit.prevent="validateForm">
                <div class="row">
                  <div class="col-12" v-if="errors.length">
                    <div>
                      <base-alert type="default">
                        <span class="alert-inner--icon">
                          <i class="ni ni-bell-55"></i>
                        </span>
                        <span class="alert-inner--text">
                          <ul style="margin: 0px;">
                            <li v-for="error of errors" v-bind:key="error">{{ error }}</li>
                          </ul>
                        </span>
                      </base-alert>
                    </div>
                  </div>
                  
                  <div
                    class="col-12"
                    role="form"
                  >
                    <div class="row">
                      <div class="col-lg-12 col-ls-12">
                          <textarea 
                          class="form-control" 
                          rows="3" 
                          placeholder="Detalle de la solicitud..."
                          v-model="complaint.description"
                          ></textarea>
                      </div>
                      
                    </div>
                    <div class="text-center">
                      <base-button 
                      nativeType="submit" 
                      type="primary" 
                      class="my-4"
                      :disabled="loading"
                      >
                      <span v-if="!sending">Enviar</span>
                      <span v-if="sending">Enviando...</span>
                      </base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>
            <template>
              
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

const axios = require("axios");


export default {
  data() {
    return {
      applied_benefits_id: this.$route.params.id,

      complaint: {
        id: null,
        email: null,
        first_name: null,
        ally: null,
        date: null,
        description: null
      },

      errors: [],
      loading: false,
      sending: false
    };
  },
  methods: {
    async validateForm(){
      this.errors = [];

      
      // Required
      if(!this.complaint.id)
        this.errors.push("Ocurrió un error al intentar enviar tu solicitud");
      

      if (this.errors.length) {
        return false;
      } else {
        return this.sendRequest();
      }
    },
    async sendRequest() {
      this.sending = true;
      
      var params = {
        complaint: this.complaint
      }

      try{
        var sendRequest = await axios.post(this.$store.state.api_url+'allies/apply-benefit/complaint-benefits-delivered', this.complaint);
        console.log(sendRequest);
      }catch(err){
        console.log(err);
        this.errors.push('Ocurrió un error intentando envíar su solicitud.')
      }
      this.sending = false;
    },
    async getAppliedBenefit(){
      this.loading = true;
      try{
        var AppliedBenefit = await axios.get(this.$store.state.api_url+'allies/apply-benefit/complaint-benefits-delivered',
        {
          params:{
            applied_benefits_id: this.applied_benefits_id
          }
        }
        );
        this.complaint = AppliedBenefit.data;
        console.log(AppliedBenefit);
      }catch(err){
        console.log(err);
      }
      this.loading = false;
    }
  },
  mounted() {
    this.getAppliedBenefit();
  }
};
</script>
<style>
</style>
